import { Drawer, SimpleToolbar, Loader, Toast } from "../../../components";
import { ConfirmationDialog } from "../../../components/confirmation-dialog";
import {
  Grid,
  Container,
  makeStyles,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Box,
  IconButton,
  Tooltip,
  Typography,
  Checkbox,
  Button,
  Hidden,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Card,
  CardContent,
} from "@material-ui/core";
import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { CustomCaption, CustomTable } from "../../../components/custom-table";
import {
  ArrowForwardRounded,
  CreateRounded,
  DeleteForever,
  DeleteOutlineRounded,
  ReplyAllRounded,
  ReplyRounded,
} from "@material-ui/icons";
import { useZonesSelection } from "../../../hooks/useZoneSelection";
import { ToggleStatus } from "../../../components/toggle-status";
import { useHistory, Link } from "react-router-dom/cjs/react-router-dom.min";
import { FilterSelector } from "../../../components/filter-selector";
import { laboratoryServices } from "../../../services";
export default function ZoneScreen() {
  const classes = useStyles();
  const { authState, signOut } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const firstRender = useRef(true);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  // options--> all, active, inactive
  const [selectionType, setSelectionType] = useState("");
  const [filteredZones, setFilteredZones] = useState([]);
  const [zoneToDelete, setZoneToDelete] = useState(null);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  const { selectedZones, addZone, deleteZone, restoreZones } =
    useZonesSelection();
  // const visibleAssigmentAllButton = useMemo(() => {
  //   return selectedZones.every((selectedZone) => {
  //     const zona = filteredZones.find((z) => z._id === selectedZone._id);
  //     return zona?.status === "active";
  //   });
  // }, [selectedZones]);
  const visibleAssigmentAllButton = selectedZones.every((selectedZone) => {
    const zona = filteredZones.find((z) => z._id === selectedZone._id);
    return zona?.status === "active";
  });
  const handleConfirmationDialog = (zone, type) => {
    if (type === "open") {
      setOpenConfirmationDialog(true);
      setZoneToDelete(zone);
    }
    if (type === "close") {
      setOpenConfirmationDialog(false);
      setZoneToDelete(null);
    }
  };
  // useEffect(() => {
  //   console.log(selectedZones);
  // }, [selectedZones]);
  const handleSelectedZones = ({ checked, zone }) => {
    if (checked) addZone(zone);
    else deleteZone(zone._id);
  };

  const handleSelectOption = (option) => {
    setSelectionType(option);
  };
  const getFilteredZone = (toFilter) => {
    return toFilter;
  };

  // must be a promise
  const handleChangeZoneStatus = async (newStatus, zone) => {
    const visitingZoneInfo = {
      ...zone,
      status: newStatus ? "active" : "inactive",
    };
    try {
      const { status, response } = await laboratoryServices.updateVisitingZone({
        visitingZoneInfo,
        token: authState.token,
      });
      setToast(true);
      setToastMessage(response.response.message);
      if (status === 200) {
        getVisitingZones();
      }
      // console.log(response);
    } catch (error) {
      console.log("error on Deleting zone", error);
    }
  };

  const handleDeleteZone = async (_id) => {
    handleConfirmationDialog({}, "close");
    try {
      setLoading(true);
      const { status, response } = await laboratoryServices.deleteVisitingZone({
        visitingZoneId: zoneToDelete._id,
        token: authState.token,
      });
      setToast(true);
      setToastMessage(response.response.message);
      if (status === 200) {
        deleteZone(_id);
        getVisitingZones();
      }
      // console.log(response);
    } catch (error) {
      console.log("error on Deleting zone", error);
    } finally {
      setLoading(false);
    }
  };

  async function getVisitingZones() {
    setLoading(true);
    laboratoryServices
      .getVisitingZones({
        laboratoryId: authState.user.laboratory._id,
        token: authState.token,
      })
      .then((res) => {
        if (res.status === 200) {
          setFilteredZones(res.response.response || []);
          // console.log(res.response.response);
        } else {
          setToast(true);
          setToastMessage("Ha ocurrido un error.");
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }
  // useEffect(() => {
  //   const setSelection = () => {
  //     if (!["all", "active", "inactive"].includes(selectionType)) {
  //       restoreZones(null);
  //       return;
  //     }

  //     const allZonesId = filteredZones.reduce((acc, zone) => {
  //       if (
  //         selectionType === "all" ||
  //         (selectionType === "active" && zone.status === "active") ||
  //         (selectionType === "inactive" && zone.status !== "active")
  //       ) {
  //         acc.push(zone._id);
  //       }
  //       return acc;
  //     }, []);

  //     restoreZones(allZonesId);
  //     // console.log(allZonesId);
  //   };
  //   if (firstRender.current) firstRender.current = false;
  //   else setSelection();
  // }, [filteredZones, selectionType]);

  useEffect(() => {
    getVisitingZones();
  }, []);
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {/* {loading && <Loader loading={true} />} */}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              onFilter={(toFilter) => getFilteredZone(toFilter)}
              noSearchBar
            />
          </Container>
          <Container maxWidth={"lg"} component={"main"}>
            <Hidden xsDown>
              <Box className={classes.header_table}>
                <Button
                  variant="text"
                  color="default"
                  component={Link}
                  to="/zones/create"
                >
                  <span>Crear zona</span>
                  <ArrowForwardRounded fontSize="small" />{" "}
                </Button>
              </Box>
            </Hidden>
            {isMobile && (
              <Box className={classes.header_table_mobile}>
                {/* {filteredZones?.length ? (
                  <Box className={classes.header_table_mobile_checkbox}>
                    <FilterSelector
                      options={[
                        { label: "Todos", value: "all" },
                        { label: "Activos", value: "active" },
                        { label: "Inactivos", value: "inactive" },
                      ]}
                      selectedOption={selectionType}
                      onHandleSelectOption={handleSelectOption}
                    />
                  </Box>
                ) : null} */}
                <Button
                  variant="contained"
                  color="primary"
                  component={Link}
                  to="/zones/create"
                  style={{ textTransform: "none" }}
                  size="small"
                >
                  Crear zona
                </Button>
              </Box>
            )}
            <CustomTable
              propsTable={{ id: "ZonesTable", style: { tableLayout: "fixed" } }}
            >
              {selectedZones.length ? (
                <CustomCaption>
                  <Box className={classes.toolbar}>
                    <Box display={"flex"} alignItems={"center"}>
                      <Checkbox
                        checked={selectedZones.length > 0 ? true : false}
                        color="primary"
                        onChange={() => restoreZones()}
                        aria-label="Deseleccionar todos"
                        id="all-uncheck"
                      />
                      <Typography component={"label"} htmlFor="all-uncheck">
                        {selectedZones.length} seleccionados
                      </Typography>
                    </Box>
                    <Box display="flex" style={{ gap: 12, flexWrap: "wrap" }}>
                      {visibleAssigmentAllButton &&
                        selectedZones.length > 1 && (
                          <Tooltip
                            title="Asignar seleccionados"
                            placement="top"
                            arrow
                          >
                            <IconButton
                              color="inherit"
                              onClick={() => {
                                history.push("/zones/assignment");
                              }}
                            >
                              <ReplyAllRounded
                                style={{ transform: "rotateY(180deg)" }}
                              />
                            </IconButton>
                          </Tooltip>
                        )}

                      {/* <Tooltip
                        title="Eliminar seleccionados"
                        placement="top"
                        arrow
                      >
                        <IconButton color="inherit">
                          <DeleteForever />
                        </IconButton>
                      </Tooltip> */}
                    </Box>
                  </Box>
                </CustomCaption>
              ) : null}
              <TableHead>
                <TableRow>
                  {/* <TableCell component="th" style={{ width: "10%" }}> */}
                  {/* {!isMobile && (
                      <FilterSelector
                        options={[
                          { label: "Todos", value: "all" },
                          { label: "Activos", value: "active" },
                          { label: "Inactivos", value: "inactive" },
                        ]}
                        selectedOption={selectionType}
                        onHandleSelectOption={handleSelectOption}
                        disabled={!filteredZones.length}
                      />
                    )} */}
                  {/* </TableCell> */}
                  <TableCell component="th" style={{ width: "30%" }}>
                    Zona
                  </TableCell>
                  <TableCell component="th" style={{ width: "20%" }}>
                    Estado
                  </TableCell>
                  <TableCell component="th" style={{ width: "50%" }}>
                    Acciones
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!filteredZones?.length && !loading && (
                  <TableRow>
                    <TableCell style={{ textAlign: "center" }} colSpan={100}>
                      No hay datos que correspondan con su búsqueda
                    </TableCell>
                  </TableRow>
                )}
                {loading && (
                  <TableRow>
                    <TableCell style={{ textAlign: "center" }} colSpan={100}>
                      <CircularProgress color="secondary" size={40} />
                    </TableCell>
                  </TableRow>
                )}
                {filteredZones?.map((zone) => {
                  const { laboratoryId, name, status: dbStatus, _id } = zone;
                  const status = dbStatus === "active";
                  return (
                    <TableRow
                      key={`row-zone-${_id}`}
                      data-status={status ? "active" : "inactive"}
                    >
                      {/* <TableCell style={{ gridColumn: "span 2", order: "-1" }}> */}
                      {/* <Checkbox
                          disabled={!status}
                          checked={
                            selectedZones.find((prev) => prev._id === _id)
                              ? true
                              : false
                          }
                          className={classes.checkbox_table}
                          aria-label="Seleccionar zona"
                          onChange={(e) =>
                            handleSelectedZones({
                              checked: e.target.checked,
                              zone: { _id, name },
                            })
                          }
                        /> */}
                      {/* </TableCell> */}
                      <TableCell
                        style={{
                          textTransform: "capitalize",
                          gridColumn: "span 3",
                          // textAlign: "center",
                          ...(!status && { opacity: "0.5" }),
                        }}
                      >
                        <Checkbox
                          style={{ marginRight: 8 }}
                          disabled={!status}
                          checked={
                            selectedZones.find((prev) => prev._id === _id)
                              ? true
                              : false
                          }
                          className={classes.checkbox_table}
                          aria-label="Seleccionar zona"
                          onChange={(e) =>
                            handleSelectedZones({
                              checked: e.target.checked,
                              zone: { _id, name },
                            })
                          }
                        />
                        {name}
                      </TableCell>
                      <TableCell style={{ gridColumn: "span 3" }}>
                        <ToggleStatus
                          active={status}
                          onClick={(newStatus) =>
                            handleChangeZoneStatus(newStatus, zone)
                          }
                        />
                      </TableCell>
                      <TableCell style={{ gridColumn: "span 3" }}>
                        <Box className={classes.action_buttons}>
                          <Tooltip title="Asignar zona" placement="top" arrow>
                            <Button
                              disabled={!status}
                              variant="outlined"
                              color="primary"
                              onClick={() => {
                                restoreZones();
                                addZone({ _id, name });
                                history.push("/zones/assignment");
                              }}
                            >
                              <Typography component="span">Asignar</Typography>
                              <ReplyRounded
                                fontSize="small"
                                style={{ transform: "rotateY(180deg)" }}
                              />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Editar zona" placement="top" arrow>
                            <Button
                              component={Link}
                              style={{ boxShadow: "none" }}
                              variant="outlined"
                              color="secondary"
                              to={`/zones/update/${_id}`}
                            >
                              <Typography component="span">Editar</Typography>
                              <CreateRounded fontSize="small" />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Eliminar zona" placement="top" arrow>
                            <Button
                              style={{ boxShadow: "none" }}
                              variant="outlined"
                              color="default"
                              onClick={() =>
                                handleConfirmationDialog(
                                  { _id, status, name },
                                  "open"
                                )
                              }
                            >
                              <Typography component="span">Eliminar</Typography>
                              <DeleteOutlineRounded fontSize="small" />
                            </Button>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </CustomTable>
            <ConfirmationDialog
              open={openConfirmationDialog}
              onClose={() => handleConfirmationDialog({}, "close")}
              onConfirm={handleDeleteZone}
              title={"Eliminar zona"}
            >
              <Box>
                <Typography>¿Está seguro que desea eliminar?</Typography>
                <Card style={{ marginBlock: 12 }} elevation={2}>
                  <CardContent>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      Zona
                    </Typography>
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{ textTransform: "capitalize" }}
                    >
                      {zoneToDelete?.name}
                    </Typography>
                    <Typography className={classes.pos} color="textSecondary">
                      <ToggleStatus
                        active={zoneToDelete?.status}
                        onClick={() => {}}
                      />
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </ConfirmationDialog>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    "& main": {
      flexGrow: 1,
    },
    "& table tbody tr": {
      [theme.breakpoints.only("xs")]: {
        backgroundColor: `hsl(from ${theme.palette.primary.light} h s calc(l + 54))`,
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
        border: "none",
        borderRadius: theme.spacing(2),
        '&[data-status="inactive"]': {
          backgroundColor: theme.palette.grey[100],
        },
      },
    },
    "& .MuiPaper-root": {
      boxShadow: "none !important",
    },
  },
  checkbox_table: { padding: 0 },
  header_table: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginBottom: "-10px",
    marginTop: 12,
    "& a": {
      textTransform: "none",
      width: "30%",
      maxWidth: 150,
      display: "flex",
      alignItems: "center",
      gap: 4,
    },
  },
  header_table_mobile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // marginBottom: "-10px",
    marginTop: 16,
  },
  header_table_mobile_checkbox: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: theme.palette.text.primary,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.5rem 1rem",
    color: "inherit",
  },
  action_buttons: {
    width: "100%",
    display: "flex",
    gap: 4,
    justifyContent: "space-evenly",
    // flexWrap: "wrap",
    "& button, & a": {
      textTransform: "none",
      flexGrow: 1,
      [theme.breakpoints.up("sm")]: {
        maxWidth: 120,
      },
    },
  },
}));
